import { render, staticRenderFns } from "./Grid1x2.vue?vue&type=template&id=46340dfa&scoped=true"
import script from "./Grid1x2.vue?vue&type=script&lang=js"
export * from "./Grid1x2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46340dfa",
  null
  
)

export default component.exports